<template>

  <InfoFatturazione />

</template>

<script>
import InfoFatturazione from '../components/fatturazione/InfoFatturazione.vue'

export default {
  pageName: 'InfoFatturazione',
  components: {
    InfoFatturazione

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
